import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { sendForgotPasswordOtp, resetPasswordApi } from "../../services/coreService";
import ButtonSpinner from "../common/ButtonSpinner";
import { useTranslation } from "react-i18next";

export default function ForgotPassword() {
    const { t } = useTranslation();
    const [step, setStep] = useState(1);
    const [email, setEmail] = useState("");
    const [otp, setOtp] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");

    // Step 1: Send OTP
    const handleSendOtp = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");
        try {
            const data = await sendForgotPasswordOtp(email);
            if (data && data.responseCode === 200) {
                setStep(2);
                setMessage(t("ForgotPassword.otp_sent", "OTP sent to your email."));
            } else {
                setMessage(data.responseMessage || t("ForgotPassword.failed_send_otp", "Failed to send OTP."));
            }
        } catch {
            setMessage(t("ForgotPassword.network_error", "Network error. Please try again."));
        }
        setLoading(false);
    };

    // Step 2: Verify OTP and update password
    const handleResetPassword = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");
        try {
            const data = await resetPasswordApi({ otp, newPassword, username: email });
            if (data && data.responseCode === 200) {
                setMessage(t("ForgotPassword.password_updated", "Password updated successfully. Please login."));
                setStep(3);
            } else {
                setMessage(data.responseMessage || t("ForgotPassword.failed_reset", "Failed to reset password."));
            }
        } catch {
            setMessage(t("ForgotPassword.network_error", "Network error. Please try again."));
        }
        setLoading(false);
    };

    return (
        <div style={{
            minHeight: "100vh",
            minWidth: "100vw",
            height: "100vh",
            width: "100vw",
            background: "#fff",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "Montserrat, Arial, sans-serif"
        }}>
            <div style={{
                width: "100%",
                maxWidth: 480,
                minHeight: 420,
                background: "#fff",
                borderRadius: 16,
                boxShadow: "none",
                padding: "40px 32px 32px 32px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                position: "relative",
                justifyContent: "center",
                boxSizing: "border-box"
            }}>
                <h2 style={{
                    textAlign: "center",
                    fontWeight: 700,
                    fontSize: 24,
                    color: "#232b35",
                    marginBottom: 24
                }}>{t("ForgotPassword.title", "Forgot Password")}</h2>
                {step === 1 && (
                    <form onSubmit={handleSendOtp} style={{ width: "100%" }}>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            background: "#f7f8fa",
                            borderRadius: 12,
                            border: "1.2px solid #e0e3e7",
                            padding: "10px 14px",
                            marginBottom: 18,
                            fontSize: 16,
                            boxSizing: "border-box",
                            boxShadow: "0 2px 8px rgba(44,62,80,0.06)",
                            width: "100%",
                        }}>
                            <span style={{ color: "#bbb", marginRight: 10, fontSize: 16 }}>📧</span>
                            <input
                                type="email"
                                placeholder={t("ForgotPassword.enter_email", "Enter Your Email")}
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                required
                                style={{
                                    border: "none",
                                    outline: "none",
                                    background: "transparent",
                                    fontSize: 16,
                                    flex: 1,
                                }}
                            />
                        </div>
                        <button
                            type="submit"
                            style={{
                                width: "100%",
                                padding: "13px 0",
                                borderRadius: 9,
                                border: "none",
                                background: "#232b35",
                                color: "#FFD600",
                                fontWeight: 700,
                                fontSize: 17,
                                cursor: loading ? "not-allowed" : "pointer",
                                marginBottom: 8,
                                letterSpacing: 1,
                                opacity: loading ? 0.6 : 1,
                                position: "relative"
                            }}
                            disabled={loading}
                        >
                            {loading ? (
                                <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <ButtonSpinner size={18} color="#FFD600" type="dots" />
                                    <span style={{ marginLeft: 8 }}>{t("ForgotPassword.sending_otp", "Sending OTP...")}</span>
                                </span>
                            ) : t("ForgotPassword.send_otp", "Send OTP")}
                        </button>
                    </form>
                )}
                {step === 2 && (
                    <form onSubmit={handleResetPassword} style={{ width: "100%" }}>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            background: "#f7f8fa",
                            borderRadius: 12,
                            border: "1.2px solid #e0e3e7",
                            padding: "10px 14px",
                            marginBottom: 18,
                            fontSize: 16,
                            boxSizing: "border-box",
                            boxShadow: "0 2px 8px rgba(44,62,80,0.06)",
                            width: "100%",
                        }}>
                            <span style={{ color: "#bbb", marginRight: 10, fontSize: 16 }}>🔑</span>
                            <input
                                type="text"
                                placeholder={t("ForgotPassword.enter_otp", "Enter OTP")}
                                value={otp}
                                onChange={e => setOtp(e.target.value)}
                                required
                                style={{
                                    border: "none",
                                    outline: "none",
                                    background: "transparent",
                                    fontSize: 16,
                                    flex: 1,
                                }}
                            />
                        </div>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            background: "#f7f8fa",
                            borderRadius: 12,
                            border: "1.2px solid #e0e3e7",
                            padding: "10px 14px",
                            marginBottom: 18,
                            fontSize: 16,
                            boxSizing: "border-box",
                            boxShadow: "0 2px 8px rgba(44,62,80,0.06)",
                            width: "100%",
                            position: "relative"
                        }}>
                            <span style={{ color: "#bbb", marginRight: 10, fontSize: 16 }}>🔒</span>
                            <input
                                type={showPassword ? "text" : "password"}
                                placeholder={t("ForgotPassword.enter_new_password", "Enter New Password")}
                                value={newPassword}
                                onChange={e => setNewPassword(e.target.value)}
                                required
                                style={{
                                    border: "none",
                                    outline: "none",
                                    background: "transparent",
                                    fontSize: 16,
                                    flex: 1,
                                }}
                            />
                            <span
                                onClick={() => setShowPassword((prev) => !prev)}
                                style={{
                                    position: "absolute",
                                    right: 14,
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    color: "#bbb",
                                    fontSize: 18,
                                    userSelect: "none"
                                }}
                                title={showPassword ? t("ForgotPassword.hide_password", "Hide Password") : t("ForgotPassword.show_password", "Show Password")}
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                        </div>
                        <button
                            type="submit"
                            style={{
                                width: "100%",
                                padding: "13px 0",
                                borderRadius: 9,
                                border: "none",
                                background: "#232b35",
                                color: "#FFD600",
                                fontWeight: 700,
                                fontSize: 17,
                                cursor: loading ? "not-allowed" : "pointer",
                                marginBottom: 8,
                                letterSpacing: 1,
                                opacity: loading ? 0.6 : 1,
                                position: "relative"
                            }}
                            disabled={loading}
                        >
                            {loading ? (
                                <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <ButtonSpinner size={18} color="#FFD600" type="dots" />
                                    <span style={{ marginLeft: 8 }}>{t("ForgotPassword.updating", "Updating...")}</span>
                                </span>
                            ) : t("ForgotPassword.update_password", "Update Password")}
                        </button>
                    </form>
                )}
                {step === 3 && (
                    <div style={{
                        textAlign: "center",
                        color: "#52c41a",
                        fontWeight: 600,
                        fontSize: 18,
                        marginTop: 24,
                        lineHeight: 1.6
                    }}>
                        <span style={{ fontSize: 22 }}>🎉 {t("ForgotPassword.password_updated_success", "Password updated successfully!")}</span>
                        <br />
                        <span style={{ fontWeight: 400, color: "#232b35", fontSize: 16 }}>
                            {t("ForgotPassword.can_now", "You can now")}&nbsp;
                            <button
                                type="button"
                                onClick={() => window.location.href = "/login"}
                                style={{
                                    color: "#FFD600",
                                    fontWeight: 700,
                                    textDecoration: "underline",
                                    borderBottom: "2px solid #FFD600",
                                    paddingBottom: 2,
                                    cursor: loading ? "not-allowed" : "pointer",
                                    background: "none",
                                    border: "none",
                                    outline: "none",
                                    transition: "border 0.2s",
                                    opacity: loading ? 0.6 : 1
                                }}
                                disabled={loading}
                            >
                                {t("ForgotPassword.login", "Login")}
                            </button>
                        </span>
                    </div>
                )}
                {message && (
                    <div style={{
                        marginTop: 12,
                        color: message.includes("success") || step === 3 ? "#52c41a" : "#ff4d4f",
                        fontWeight: 500,
                        fontSize: 15,
                        textAlign: "center"
                    }}>
                        {message}
                    </div>
                )}
            </div>
        </div>
    );
}